import { Chakra } from "@airhelp/react-ui-components";
import { ArrowRightIcon } from "styles/icons";
import type { NextButtonProps } from "./NextButton.d";

const { Button } = Chakra;

const NextButton = ({ nextPage, canNextPage }: NextButtonProps) => (
  <Button
    variant="unstyled"
    onClick={nextPage}
    disabled={!canNextPage}
    color="greyscale.600"
    d="flex"
    alignItems="center"
    sx={{ svg: { boxSize: 4 } }}
  >
    <ArrowRightIcon />
  </Button>
);
export default NextButton;
